import { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import { Button, useUI } from '@components/ui'
import WalletIcon from '@components/icons/walletIcon'
import { formatWalletAccount } from '@lib/web3/helpers/formatWalletAccount'
import { isSuccess, useCustomer } from '@lib/api'
import { useENSName } from '@lib/web3/CryptoWallet/helpers/useENSName'

const defaultAvatarPath = '/public/default-owl-avatar-grey-256x256.png'

export const ConnectCTAComponent = () => {
  const { t } = useTranslation()
  const { toggleSidebar, setSidebarView, closeSidebar } = useUI()
  const [userAvatar, setUserAvatar] = useState(defaultAvatarPath)
  const customerData = useCustomer()

  const walletId = isSuccess(customerData) ? customerData.data.walletId : null

  useEffect(() => {
    async function loadAvatarForWalletId() {
      if (walletId === null) {
        setUserAvatar(defaultAvatarPath)

        return
      }

      const { getAvatarForWalletId } = await import('@lib/web3/helpers/avatar')

      const avatar = await getAvatarForWalletId(walletId)

      if (avatar === null) {
        setUserAvatar(defaultAvatarPath)

        return
      }

      setUserAvatar(avatar)
    }

    void loadAvatarForWalletId()
  }, [walletId])

  const walletENSName = useENSName(walletId)

  const connect = () => {
    setSidebarView('WALLET_VIEW', () => {
      closeSidebar()
    })
    toggleSidebar()
  }

  const shouldShowWallet = walletId !== null

  return (
    <Button
      variant="naked"
      onClick={connect}
      aria-label={t('common:connect_wallet').toLocaleLowerCase()}
    >
      {shouldShowWallet ? (
        <>
          <div className="h-11 w-11 mr-2 relative rounded-full overflow-clip">
            <Image
              loading="lazy"
              src={userAvatar}
              alt="Default avatar grey owl"
              fill
            />
          </div>
          <span className="font-normal normal-case">
            {walletENSName ?? formatWalletAccount(walletId)}
          </span>
        </>
      ) : (
        <div className="flex items-center p-2.5 w-max">
          <WalletIcon className="mr-2" />
          {t('common:connect_wallet')}
        </div>
      )}
    </Button>
  )
}

export const ConnectCTA = () => {
  return <ConnectCTAComponent />
}
